import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

/**
 * T4-144: the reviewed QuickBooks import - the same mutation as ImportQuickbooksCustomersMutation, with `resolutions`
 * (QuickbooksClientMatchResolution, given even when empty) and reading how many confirmed pairings could not be
 * linked. A document of its own, so the plain import's request stays exactly today's: a graphql rolled back to before
 * `unlinkedConfirmedCount` still accepts it.
 */
const mutation = graphql`
	mutation ImportQuickbooksCustomersReviewedMutation($input: ImportQuickbooksCustomersInput!) {
		importQuickbooksCustomers(input: $input) {
			company {
				clients(first: 10000) {
					edges {
						node {
							id
							name
							notes
							logoId
							logoDefaultId
							projectCount
							xeroContactId
						}
					}
				}
			}
			unlinkedConfirmedCount
			unlinkedBillToCount
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
